import React, { createContext, useContext, useMemo, useState } from 'react';
import type { PlannerAnswers, ServiceType, SubmissionRecord } from '../types/mcf';
type EnquiryContextValue = {
  selectedService: ServiceType;
  setSelectedService: (service: ServiceType) => void;
  plannerAnswers: PlannerAnswers;
  setPlannerAnswers: (answers: PlannerAnswers) => void;
  selectedProject: string;
  setSelectedProject: (project: string) => void;
  enquiryDraft: SubmissionRecord | null;
  setEnquiryDraft: (draft: SubmissionRecord) => void;
  formActive: boolean;
  setFormActive: (active: boolean) => void;
  goToQuote: (service?: ServiceType) => void;
};
const defaultPlannerAnswers: PlannerAnswers = {
  priority: null,
  scope: null,
  control: null
};
const EnquiryContext = createContext<EnquiryContextValue | null>(null);
export function EnquiryProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selectedService, setSelectedService] = useState<ServiceType>('roller-shutters');
  const [plannerAnswers, setPlannerAnswers] = useState<PlannerAnswers>(defaultPlannerAnswers);
  const [selectedProject, setSelectedProject] = useState('');
  const [enquiryDraft, setEnquiryDraft] = useState<SubmissionRecord | null>(null);
  const [formActive, setFormActive] = useState(false);
  const goToQuote = (service?: ServiceType) => {
    if (service) setSelectedService(service);
    window.setTimeout(() => {
      document.getElementById('quote')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 0);
  };
  const value = useMemo(() => ({
    selectedService,
    setSelectedService,
    plannerAnswers,
    setPlannerAnswers,
    selectedProject,
    setSelectedProject,
    enquiryDraft,
    setEnquiryDraft,
    formActive,
    setFormActive,
    goToQuote
  }), [selectedService, plannerAnswers, selectedProject, enquiryDraft, formActive]);
  return <EnquiryContext.Provider value={value} data-id="element-569" data-mp="tdp9wjv3xm6t">{children}</EnquiryContext.Provider>;
}
export function useEnquiry() {
  const context = useContext(EnquiryContext);
  if (!context) throw new Error('useEnquiry must be used inside EnquiryProvider');
  return context;
}